export default __webpack_public_path__ + "static/B0298-cb2662f5c0aa2535898af484b411194f.png";